module.exports = __webpack_public_path__ + "img/stars.3bd47398.svg";